module.exports = __webpack_public_path__ + "static/chakradhar-ca28ec5525398cf9c5f854e90ab925ee.jpg";